import menu from './store/menu';
import menuTable from './store/menuTable'
import store from '@/core/store';

export const connect = (opts = {}) => {
  store.registerModule('menus$menus', menu);
  store.registerModule('menus$menusTable', menuTable);
};
